<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tmepnX/tc-custom/9781466830486.jpg?1720009287089" alt="This image is the cover for the book When Blanche Met Brando"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">When Blanche Met Brando
      </h1>
      <p class="bookDescription body article font2">
        <p>Exhaustively researched and almost flirtatiously opinionated, W<i>hen Blanche Met Brando</i> is everything a fan needs to know about the ground-breaking New York and London stage productions of Williams' "Streetcar" as well as the classic Brando/Leigh film. Sam Staggs' interviews with all the living cast members of each production will enhance what's known about the play and movie, and help make this book satisfying as both a pop culture read and as a deeper piece of thinking about a well-known story. <br/><br/>Readers will come away from this book delighted with the juicy behind-the-scenes stories about cast, director, playwright and the various productions and will also renew their curiosity about the connection between the role of Blanche and Viven Leigh's insatiable sexual appetite and later descent into breakdown. They may also-for the first time-question whether the character of Blanche was actually "mad" or whether her anxiousness was symptomatic of another disorder.<br/><br/>"A Streetcar Named Desire" is one of the most haunting and most-studied modern plays. Staggs' new book will fascinate fans and richen newcomers' understanding of its importance in American theater and movie history.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sam Staggs
      </h2>
      
      <p class="authorDescription body article"><B>Sam Staggs</B> is the author of <I>All About All About Eve</I> and <I>Close-Up On</I><I>Sunset Boulevard</I>.  He has written for a variety of publications, including <I>Vanity Fair </I>and <I>Architectural Digest</I>. He lives in Dallas, Texas.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2ef82a5c